import React, { Fragment } from 'react';
import '../about/css/content.css';
import bg1 from '../../images/banner/b3.jpg';
import bg2 from '../../images/banner/b5.jpg';


const Content = () => {
    return (
       
           <Fragment>
                <div className="Total_Content">
                <div className="Content">
                <h3 >About Us</h3>
                <h2>What We Can Do?</h2>
                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
                    Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, 
                    when an unknown printer took a galley of type and scrambled it to make a type specimen book. 
                    It has survived not only five centuries, but also the leap into electronic typesetting, remaining 
                    essentially unchanged.</p>    
            </div>
             <div className="Content_second" data-aos="fade-up"  data-aos-duration="1000">
                <div className="content_img">
                    <div className="img">
                            <img src={bg1} alt='Harshitha developers & constructions prayer city' width="100%" height="100%" />
                        </div>
                        
                    <div className="content_img_body">
                            
                                <h3>Digital Bussiness</h3>
                                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. 
                                    Quisquam quis earum pariatur inventore reprehenderit, a 
                                    facere ab adipisci? Sunt voluptatibus, rerum blanditiis 
                                    aliquid pariatur officia aliquam eaque ullam id laudantium.</p>               
                            
                        </div>
                </div>
                <div className="content_img">
                    <div className="img">
                        <img src={bg2} alt='Harshitha developers & constructions prayer city' width="100%" height="100%" />
                    </div>
                        <div className="content_img_body">
                           
                                <h3> Integrated Bussiness</h3>
                                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. 
                                    Quisquam quis earum pariatur inventore reprehenderit, a 
                                    facere ab adipisci? Sunt voluptatibus, rerum blanditiis 
                                    aliquid pariatur officia aliquam eaque ullam id laudantium.</p>        
                           
                        </div>
                </div>
            </div>
                </div>
         
           </Fragment>
    )
}

export default Content;